import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const NAV_LINKS = [{
  name: 'Home',
  href: '/'
}, {
  name: 'About',
  href: '/about'
}, {
  name: 'Experience',
  href: '/experience'
}, {
  name: 'Projects',
  href: '/projects'
}, {
  name: 'Contact',
  href: '/contact'
}];
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsMobileMenuOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-navy-900/95 backdrop-blur-md py-3 shadow-lg' : 'bg-transparent py-5'}`} data-id="element-26">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-27">
        <Link to="/" className="text-white font-serif text-2xl font-bold tracking-wider" aria-label="Bryan E. Nicholson Home" data-id="element-28">
          Bryan E. Nicholson
        </Link>

        <nav className="hidden md:flex items-center space-x-8" aria-label="Main navigation" data-id="element-29">
          {NAV_LINKS.map(link => {
          const isActive = location.pathname === link.href;
          return <Link key={link.name} to={link.href} className={`text-sm font-medium tracking-wide transition-colors ${isActive ? 'text-gold' : 'text-white/80 hover:text-gold'}`} data-id="element-30">
                {link.name}
                {isActive && <motion.div layoutId="nav-indicator" className="h-0.5 bg-gold mt-1 rounded-full" transition={{
              type: 'spring',
              stiffness: 300,
              damping: 30
            }} data-id="element-31" />}
              </Link>;
        })}
        </nav>

        <button className="md:hidden text-white p-2 focus:outline-none" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle mobile menu" data-id="element-32">
          {isMobileMenuOpen ? <XIcon size={24} data-id="element-33" /> : <MenuIcon size={24} data-id="element-34" />}
        </button>
      </div>

      <AnimatePresence data-id="element-35">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-navy-900 border-t border-white/10 overflow-hidden" data-id="element-36">
            <nav className="flex flex-col px-6 py-4 space-y-4" data-id="element-37">
              {NAV_LINKS.map(link => {
            const isActive = location.pathname === link.href;
            return <Link key={link.name} to={link.href} className={`text-base font-medium py-2 transition-colors ${isActive ? 'text-gold' : 'text-white/80 hover:text-gold'}`} data-id="element-38">
                    {link.name}
                  </Link>;
          })}
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}